import React from 'react';

var LoadingPlaceholder = function LoadingPlaceholder(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg" // hide from AT users since an AT user likely doesn't need to know an icon is loading
    ,
    "aria-hidden": "true",
    role: "presentation"
  }, /*#__PURE__*/React.createElement("title", null, "Icon Loading"), /*#__PURE__*/React.createElement("rect", {
    width: size,
    height: size,
    fill: "none"
  }));
};

export { LoadingPlaceholder as default };
